﻿var scalasans = {
      src: 'http://static0.shopify.com/s/files/1/0018/7872/assets/scalasans.swf'
};
 
sIFR.activate(scalasans);

sIFR.replace(scalasans, {
      selector: 'h2.sifr', 
      transparent:true,
      forceSingleLine:true,
      selectable:false,
      css: [
            'a {color:#333333;text-decoration:none;}',
            'a:hover {color:#cc0000;background-color:#cc0000;}'
      ]
});
 